import { useQuery, type QueryClient } from '@tanstack/react-query';

import { type AuditId } from '#packages/data-collection/models/audit';

import { AUDITS_QUERY_KEY } from '#apps/client-web/features/audit/types/react-query';
import {
  type AuditService,
  type CollectionName,
} from '#apps/client-web/features/audit/services/audit';

export const useLoadAuditByIdQuery = ({
  auditService,
  queryClient,
  collectionName,
  auditId,
}: {
  auditService: AuditService;
  queryClient: QueryClient;
  collectionName: CollectionName;
  auditId: AuditId;
}) =>
  useQuery(
    {
      queryKey: [AUDITS_QUERY_KEY, auditId],
      queryFn: auditService.loadById.bind(auditService, {
        collectionName,
        auditId,
      }),
    },
    queryClient,
  );
